/**
 * Determine duration of an audio file's contents.
 */
export async function getAudioFileDurationSeconds(audioFile: Blob): Promise<number> {
  const tempUrl = URL.createObjectURL(audioFile)
  const audio = new Audio(tempUrl)
  try {
    return await getAudioDurationSeconds(audio)
  } finally {
    URL.revokeObjectURL(tempUrl)
  }
}

/**
 * Determine duration of an HTMLAudioElement.
 * Will pause the element and seek it to 0.
 */
export function getAudioDurationSeconds(audio: HTMLAudioElement): Promise<number> {
  audio.pause()
  return new Promise((resolve, reject) => {
    audio.addEventListener('canplay', () => {
      if (isFinite(audio.duration)) {  // firefox
        resolve(audio.duration)
      } else {  // chrome, see https://stackoverflow.com/questions/38443084/ and https://issues.chromium.org/issues/40482588
        audio.addEventListener('timeupdate', () => {
          audio.currentTime = 0
          resolve(audio.duration)
        }, {once: true})
        audio.currentTime = 1e10
      }
    }, {once: true})
  })
}
